module.exports = __webpack_public_path__ + "static/media/DAI.316b9981.svg";